"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduxFormWorksheet;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactConfirm = require("@flowio/react-confirm");
var _actions = require("./actions");
var _selectors = require("./selectors");
var _excluded = ["caption", "className", "disabled", "okText", "intent", "onCancel", "onOk", "open"];
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
function reduxFormWorksheet(initialConfig) {
  return function createReduxFormWorksheet(Form) {
    var config = _objectSpread({
      getFormOverlayState: _selectors.defaultStateSelector
    }, initialConfig);
    var ReduxForm = (0, _reduxForm.reduxForm)(config)(Form);
    function ReduxFormConfirm(_ref) {
      var caption = _ref.caption,
        className = _ref.className,
        disabled = _ref.disabled,
        okText = _ref.okText,
        intent = _ref.intent,
        onCancel = _ref.onCancel,
        onOk = _ref.onOk,
        open = _ref.open,
        unhandledProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
      return /*#__PURE__*/_react.default.createElement(_reactConfirm.Confirm, {
        caption: caption,
        className: className,
        disabled: disabled,
        okText: okText,
        intent: intent,
        onCancel: onCancel,
        onOk: onOk,
        open: open
      }, /*#__PURE__*/_react.default.createElement(ReduxForm, unhandledProps));
    }
    ReduxFormConfirm.displayName = 'ReduxFormConfirm';
    ReduxFormConfirm.propTypes = {
      caption: _propTypes.default.node,
      className: _propTypes.default.string,
      disabled: _propTypes.default.bool,
      okText: _propTypes.default.string,
      intent: _propTypes.default.string,
      onCancel: _propTypes.default.func,
      onOk: _propTypes.default.func,
      open: _propTypes.default.bool
    };
    ReduxFormConfirm.defaultProps = {
      caption: undefined,
      className: undefined,
      disabled: false,
      okText: undefined,
      intent: undefined,
      onCancel: undefined,
      onOk: undefined,
      open: false
    };
    function mapStateToProps(state, ownProps) {
      var form = ownProps.form,
        getFormOverlayState = ownProps.getFormOverlayState;
      var stateProps = (0, _selectors.getOverlayProps)(form, getFormOverlayState)(state);
      return _objectSpread(_objectSpread({}, stateProps), {}, {
        disabled: (0, _reduxForm.isSubmitting)(form, getFormOverlayState)(state)
      }, ownProps);
    }
    function mapDispatchToProps(dispatch, ownProps) {
      return {
        onCancel: function onCancel() {
          var form = ownProps.form,
            onCancel = ownProps.onCancel;
          dispatch((0, _actions.close)(form));
          if (onCancel) onCancel.apply(void 0, arguments);
        },
        onOk: function onOk() {
          var form = ownProps.form,
            onOk = ownProps.onOk;
          dispatch((0, _reduxForm.submit)(form));
          if (onOk) onOk.apply(void 0, arguments);
        },
        onSubmitSuccess: function onSubmitSuccess() {
          var form = ownProps.form,
            onSubmitSuccess = ownProps.onSubmitSuccess;
          dispatch((0, _actions.close)(form));
          if (onSubmitSuccess) onSubmitSuccess.apply(void 0, arguments);
        }
      };
    }
    var ConnectedReduxFormConfirm = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReduxFormConfirm);
    ConnectedReduxFormConfirm.defaultProps = config;
    return ConnectedReduxFormConfirm;
  };
}